export const HL_INFO_URL     = 'https://api.hyperliquid.xyz/info';
export const HL_EXCHANGE_URL = 'https://api.hyperliquid.xyz/exchange';
export const HL_WS_URL       = 'wss://api.hyperliquid.xyz/ws';

// EIP-712 domain used for ALL HL order signing — chainId 1337 is HL's own L1.
// The wallet does NOT need to be on this chain; MetaMask/Rabby sign it as typed data.
export const HL_DOMAIN = {
  chainId: 1337,
  name: 'Exchange',
  verifyingContract: '0x0000000000000000000000000000000000000000',
  version: '1',
};

// EIP-712 types for the phantom agent (used for all L1 actions: orders, leverage, cancel)
export const HL_AGENT_TYPES = {
  Agent: [
    { name: 'source',       type: 'string'  },
    { name: 'connectionId', type: 'bytes32' },
  ],
};

// Market order slippage tolerance — IOC limit buffer (HL Python SDK default = 0.05)
export const HL_SLIPPAGE = 0.05;

// Minimum position in USD — actual minimum is asset-dependent (0.001 BTC ≈ $97 at $97K)
// The placeMarketOrder function validates the coin lot size and throws a clear error.
export const HL_MIN_SIZE_USD = 10;

// Markets shown by default in the panel (panel fetches full list from API)
export const DEFAULT_MARKETS = ['BTC'];

// CoinGecko IDs for analytics overlay (BTC only for now)
export const CG_IDS = { BTC: 'bitcoin', ETH: 'ethereum' };

// Leverage steps shown in the panel
export const LEVERAGES = [1, 2, 5, 10, 20, 50];
